import { IAdminTeamGame, IAdminTeamGamesStore, ITeamGameBase } from './store';

import api, { request } from '../../../api';
import { groupBy } from '../../../contrib/utils';
import { IErrorsStore } from '../../errors/store';
import { IActionGroup, IStore } from '../../index';

export interface IAdminTeamGamesActions extends IActionGroup {
  create: (
    clubId: string,
    eventId: string,
    roundId: string,
    teamGameBase: ITeamGameBase
  ) => { adminTeamGames?: IAdminTeamGamesStore; errors?: IErrorsStore };
  delete: (
    clubId: string,
    eventId: string,
    roundId: string,
    teamGame: IAdminTeamGame
  ) => { adminTeamGames?: IAdminTeamGamesStore; errors?: IErrorsStore };
  get: (
    clubId: string,
    eventId: string,
    roundId: string,
    force?: boolean
  ) => { adminTeamGames?: IAdminTeamGamesStore; errors?: IErrorsStore };
}

const actions: IActionGroup = {
  create: async (
    state: IStore,
    clubId: string,
    eventId: string,
    roundId: string,
    teamGameBase: ITeamGameBase
  ) => {
    const response = await request.post(
      api.admin.teamGames(clubId, eventId, roundId),
      teamGameBase
    );

    if (response.error) {
      return { errors: { adminTeamGames: { msg: 'Error retrieving the Event Round Details.' } } };
    }

    return {
      ...state,
      adminTeamGames: {
        ...state.adminTeamGames,
        [teamGameBase.group]: state.adminTeamGames[teamGameBase.group]
          ? [...state.adminTeamGames[teamGameBase.group], response]
          : [response]
      }
    };
  },
  delete: async (
    state: IStore,
    clubId: string,
    eventId: string,
    roundId: string,
    teamGameToDelete: IAdminTeamGame
  ) => {
    const response = await request.delete(
      api.admin.teamGames(clubId, eventId, roundId, teamGameToDelete.id)
    );

    if (response.error) {
      return { errors: { adminTeamGames: { msg: 'Error retrieving the Event Round Details.' } } };
    }

    const remainintTeamGames = state.adminTeamGames[teamGameToDelete.group].filter(
      teamGame => teamGameToDelete.id !== teamGame.id
    );

    return {
      ...state,
      adminTeamGames: {
        ...state.adminTeamGames,
        [teamGameToDelete.group]: remainintTeamGames
      }
    };
  },
  get: async (state: IStore, clubId: string, eventId: string, roundId: string, force?: boolean) => {
    if (roundId && state.adminTeamGames[Number(roundId)] && !force) {
      return { adminTeamGames: state.adminTeamGames };
    }

    const response = await request.get(api.admin.teamGames(clubId, eventId, roundId));

    if (response.error) {
      return { errors: { adminTeamGames: { msg: 'Error retrieving the Event Round Details.' } } };
    }

    return {
      ...state,
      adminTeamGames: groupBy(response, 'group')
    };
  }
};

export default actions;
